import "./IllustUnion.scoped.scss";
import img_assemble from "../../img/illusts/assemble.png";
import img_assemble_large from "../../img/illusts/assemble_large.png";
import { useEffect, useRef } from "react";

interface Props {
  onClickIllust: (path: string) => void;
}

export default function IllustUnion(props: Props) {
  //--------------------
  // Workaround:
  //  ページ遷移時にアニメーションしていないように見えるので(React側ではなくシステム内部の)描画更新を促す。
  //  奇妙なことに、デバッグツールで見た感じエレメントの領域はちゃんとアニメーションしていた。
  //--------------------
  const img = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (img.current) {
      const style = img.current.style;
      style.animationPlayState = "running";
    }
    return;
  });

  return (
    <div className="root flex-row">
      <div className="assemble-img-space">
        <img
          ref={img}
          src={img_assemble}
          alt="集合イラスト"
          className="assemble-img"
          onClick={() => {
            props.onClickIllust(img_assemble_large);
          }}
        ></img>
      </div>
      <div className="bg-white rounded-2xl text-red-700 w-full xl:text-2xl md:text-xl text-sm py-5">
        &lt;&lt;鈴谷アキ誕生祭 アキネコ合作イラスト 2021.11.28&gt;&gt;
        <br />
        誕生日を記念して合作イラストを制作しました！
      </div>
    </div>
  );
}
